<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full tw-relative tw-py-12 lg:tw-py-56">
            <h2>Obrigado!</h2>
            <p>Será contactado brevemente.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    width: auto;
    height: 100%;
    @screen lg {
        margin-left: auto;
        max-width: 380px;
        max-height: 770px;
    }

    h2 {
        color: #FFF;
        font-weight: 700;
        font-size: 22px;
        line-height: 26px;
        @screen lg {
            font-size: 26px;
            line-height: 31px;
        }
    }

    p {
        color: #FFF;
        font-weight: 700;
        font-size: 15px;
        @screen lg {
            line-height: 26px;
        }
    }
}

</style>
